import { APIClient } from "smartassess-api-lib";
import { CommonEnums } from "../../utils/Enums/CommonEnums";

const apiClient = new APIClient();

let currentLanguage =
  localStorage.getItem("currentLanguage") ?? CommonEnums.LANGUAGE_EN;
export const initializeApiClient = (lang: string) => {
  currentLanguage = lang;
  apiClient.initializeApiClient(
    `${process.env.REACT_APP_API}`,
    localStorage.getItem("companyToken") ?? "",
    false,
    () => {
      window.location.href = "/";
      APIClient.setApiToken("");
      localStorage.clear();
    },
    lang,
  );
};

initializeApiClient(currentLanguage);

export default apiClient;
